import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import * as d from "../../reducers/domainReducer";
import * as types from "../../constants/actionTypes";
import { firstNameFirst } from "../../helpers/formatting";
import MyChartUsers from "./MyChartUsers";
import PharmacyUsers from "./PharmacyUsers";
import FamilyPlanUsers from "./FamilyPlanUsers";
import MiniSpinner from "../common/MiniSpinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class UsersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dropdownOpen: false };
        this.props.getPharmacyUsers();
    }

    componentDidMount() {
        logUI("MBHWeb.UI.UsersList.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const {
            primaryUser, activeUser, myChartUsers, pharmacyUsers, onPrimaryUserSelected, onMyChartUserSelected,
            onPharmacyUserSelected, rxDown, hasPharmacyLogin, bundle, history, schedulingCompleted, orderRefillCompleted,
            rxTransferCompleted, serverData, hasAAL, hasHealthPlanLogin, onFamilyPlanUserSelected
        } = this.props;

        const enableFamilyPlan = serverData && serverData.combinedhp ? (hasAAL || hasHealthPlanLogin ? true : false) : false;
        const familyPlanUsers = [
            { id: 1, familyMember: "Father" },   //Mock data for family plan insurance.
            { id: 2, familyMember: "Mother" }
        ];
        const myChartUsersCount = myChartUsers ? myChartUsers.length : 0;
        const pharmacyUsersCount = pharmacyUsers ? pharmacyUsers.length : 0;
        const familyPlanUsersCount = familyPlanUsers && enableFamilyPlan ? familyPlanUsers.length : 0;
        const totalUsersCount = myChartUsersCount + pharmacyUsersCount + familyPlanUsersCount;
        let pathname = history && history.location ? history.location.pathname : '/';
        const rxRequestCompleted = (orderRefillCompleted && /rxrefill/.test(pathname.toLowerCase())) || (rxTransferCompleted && /bswtransfer/.test(pathname.toLowerCase()));

        if (rxRequestCompleted) {
            pathname = '/pharmacy';
        }
        else if (pathname !== '/' && ((rxDown || !hasPharmacyLogin) && (bundle === "pharmacy" || pathname.indexOf('/pharmacy') > -1) ||
            /^\/schedule\//.test(pathname) && schedulingCompleted)) {
            pathname = '/';
        }
        //else if (history && history.location && !(/^\/schedule\//.test(pathname) && schedulingCompleted)) {
        //    pathname = history.location.pathname;
        //}

        //debugger;
        //if (myChartUsers === null ||
        //    pharmacyUsers === null) {
        //    return <div className="proxy-dropdown"><MiniSpinner /></div>;
        //}
        if (totalUsersCount === 0) {
            return null;
        }


        return (
            <div className="proxy-dropdown">
                <Dropdown
                    isOpen={this.state.dropdownOpen}
                    toggle={() => this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }))}
                >
                    <DropdownToggle className="user-avatar">
                        <div className="user-avatar__btn">
                            {totalUsersCount} +
                         </div>
                    </DropdownToggle>

                    <DropdownMenu>
                        <DropdownItem header>Your Account</DropdownItem>

                        {!activeUser || !activeUser.index
                            ? <DropdownItem>{firstNameFirst(primaryUser.displayName)}</DropdownItem>
                            : <Link to={{ pathname: pathname }}>
                                <DropdownItem onClick={() => onPrimaryUserSelected(primaryUser)}>
                                    {firstNameFirst(primaryUser.displayName)}
                                </DropdownItem>
                            </Link>
                        }

                        {myChartUsersCount > 0 &&
                            <MyChartUsers list={myChartUsers} onUserSelected={onMyChartUserSelected} activeUser={activeUser} bundle={bundle} />
                        }

                        {pharmacyUsersCount > 0 &&
                            <PharmacyUsers list={pharmacyUsers} onUserSelected={onPharmacyUserSelected} activeUser={activeUser} />
                        }
                        {enableFamilyPlan && familyPlanUsersCount > 0 &&
                            <FamilyPlanUsers list={familyPlanUsers} onUserSelected={onFamilyPlanUserSelected} />
                        }
                    </DropdownMenu>
                </Dropdown>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    let pl = [];

    if (state.domain.pl) {
        state.domain.pl.forEach((c, index, arr) => {
            pl.push(d.hydrateProxyUser(c));
        });

    }

    if (pl.length > 0) {
        pl.shift(); // remove the logged-in user from the list
    }

    const pharmacyUsers = state.common[types.PHARMACY_PROXY_ACCESS_LIST];
    const { submitOrderResult, transfer } = state.pharmacy;

    return {
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.domain.hp,
        myChartUsersLoading: state.header.proxyListLoading,
        myChartUsers: pl,
        pharmacyUsers: pharmacyUsers && pharmacyUsers.response ? pharmacyUsers.response : null,
        bundle: state.session.serverData.bundle.toLowerCase(),
        history: state.session.history,
        schedulingCompleted: state.openScheduling.scheduleAppointmentSuccess || state.openScheduling.scheduleAppointmentFailed,
        orderRefillCompleted: submitOrderResult && (submitOrderResult.SuccessRx || submitOrderResult.RenewedRx || submitOrderResult.FailuresRx),
        rxTransferCompleted: transfer && (transfer.error || transfer.result),
        hasAAL: !state.common.aalDown && state.domain.aal,
        hasHealthPlanLogin: !state.common.swhpDown && state.domain.hh,
        serverData: state.session.serverData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPharmacyUsers: () => dispatch({ type: types.PHARMACY_PROXY_ACCESS_LIST })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersList);